import axios from 'axios';

const api = axios.create({
  baseURL: 'https://us-central1-studiooj-fb115.cloudfunctions.net/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
